import { useTranslation } from 'react-i18next';
import { NotificationContentRead } from './notificationContent/NotificationContentRead';
import { NotificationContentWrite } from './notificationContent/NotificationContentWrite';

const NotificationHeader = ({ textContent, onChange, canEdit }) => {
  const { t: translator } = useTranslation();

  if (canEdit) {
    return (
      <NotificationContentWrite
        textContent={textContent}
        onChange={onChange}
        header={translator('notificationContent.header')}
        ariaLabel={translator('ariaLabel.notificationHeaderWrite')}
      />
    );
  }
  return (
    <NotificationContentRead
      textContent={textContent}
      header={translator('notificationContent.header')}
      ariaLabel={translator('ariaLabel.notificationHeaderRead')}
    />
  );
};

export { NotificationHeader };
